export interface TabItem<T extends string> {
  id: T;
  label: string;
  /** Số đếm nhỏ cạnh nhãn (vd. số hội thoại chưa đọc). */
  count?: number;
  testId?: string;
}

/** Thanh tab / bộ lọc (role tablist); phím ←/→ chuyển mục như mẫu WAI-ARIA. */
export function Tabs<T extends string>({
  items,
  value,
  onChange,
  label,
  variant = 'line',
}: {
  items: readonly TabItem<T>[];
  value: T;
  onChange: (id: T) => void;
  label: string;
  variant?: 'line' | 'pill';
}) {
  return (
    <div
      className={`ws-tabs ws-tabs-${variant}`}
      role="tablist"
      aria-label={label}
      onKeyDown={(e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        const i = items.findIndex((t) => t.id === value);
        const next = items[(i + (e.key === 'ArrowRight' ? 1 : items.length - 1)) % items.length];
        if (!next) return;
        onChange(next.id);
        (e.currentTarget.querySelector(`[data-tab="${next.id}"]`) as HTMLElement | null)?.focus();
      }}
    >
      {items.map((t) => (
        <button
          key={t.id}
          type="button"
          role="tab"
          data-tab={t.id}
          data-testid={t.testId}
          aria-selected={t.id === value}
          tabIndex={t.id === value ? 0 : -1}
          className={t.id === value ? 'is-selected' : undefined}
          onClick={() => onChange(t.id)}
        >
          {t.label}
          {!!t.count && <span className="ws-tab-count">{t.count > 99 ? '99+' : t.count}</span>}
        </button>
      ))}
    </div>
  );
}
